import { createRouter, createWebHistory } from "vue-router";

// Lazy-loaded views（初期表示を軽くするため遅延ロード）
const Home = () => import(/* webpackChunkName: "home" */ "../views/Home.vue");
const Gallery = () => import(/* webpackChunkName: "gallery" */ "../views/Gallery.vue");

// App.vue の CSS 変数 `--header-h` から、固定ヘッダー分のオフセット(px)を取得
// 例: :root { --header-h: 96px } / モバイルでは 88px に変化
function getHeaderOffsetPx() {
  try {
    const raw = getComputedStyle(document.documentElement)
      .getPropertyValue("--header-h")
      .trim();
    const value = Number.parseInt(raw.replace("px", ""), 10);
    return Number.isFinite(value) ? value : 96;
  } catch {
    return 96;
  }
}

// ユーザーが「動きを減らす」を選んでいる場合は、JSスクロールもスムーズにしない
function prefersReducedMotion() {
  return !!window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
}

const routes = [
  { path: "/", component: Home },
  { path: "/gallery", component: Gallery },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // ブラウザの戻る/進む時は元の位置へ
    if (savedPosition) {
      return savedPosition;
    }

    // ハッシュがある場合は、その要素へスムーズスクロール
    if (to.hash) {
      // ヘッダー分のオフセット（App.vue の --header-h と常に一致させる）
      const headerHeight = getHeaderOffsetPx();
      const el = document.querySelector(to.hash);
      if (el) {
        const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
        // Vue Router は position オブジェクトを返すとスクロール制御できる
        const behavior = prefersReducedMotion() ? "auto" : "smooth";
        window.scrollTo({ top, behavior });
        // 手動でスクロールしたので false を返してデフォルト動作を抑制
        return false;
      }
      // 要素がまだ無い場合（遅延ロードなど）はデフォルトのアンカー挙動
      return { el: to.hash };
    }

    // デフォルトは先頭へ
    return { top: 0 };
  },
});

export default router;
